import React, { useEffect, useState } from 'react';
import { Button, Card, Pill } from '../components/Primitives';
import { Icon } from '../components/Icon';
import { useApp } from '../lib/app-context';
import { createAccountLinkCode, exportAccountData, redeemAccountLinkCode, redeemLicenseHubKey, requestAccountDeletion } from '../lib/cloud';
import { scheduleDailyStudyReminder } from '../lib/notifications';
import { signOut, cloudConfigured } from '../lib/supabase';
import { buildOfflinePack, offlineStatus } from '../lib/offline';
import { calendarSnapshot } from '../lib/calendar';

export function Profile() {
  const { state, updateProfile, updateSettings, setState, setRoute, syncNow, entitlement } = useApp();
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [linkCode, setLinkCode] = useState('');
  const [linkInput, setLinkInput] = useState('');
  const [offline, setOffline] = useState('Tekshirilmoqda…');
  const [syncing, setSyncing] = useState(false);
  const telegramSurface = window.location.pathname.startsWith('/telegram');
  const calendar = calendarSnapshot(state);

  useEffect(() => {
    void offlineStatus(state.progress.day)
      .then((result) => setOffline(`${result.connected ? 'Online' : 'Offline'} · Day ${result.pack.startDay}–${result.pack.endDay} pack`))
      .catch(() => setOffline('Offline pack unavailable'));
  }, [state.progress.day]);

  const activate = async () => {
    setMessage('SysOne License Hub tekshirmoqda...');
    try {
      const data = await redeemLicenseHubKey(code);
      if (data.active && data.expires_at) {
        setState((current) => ({ ...current, profile: { ...current.profile, proUntil: data.expires_at } }));
        setCode('');
        setMessage(`PRO faollashdi${data.plan_name ? ` · ${data.plan_name}` : ''}.`);
      } else setMessage(`Access ochilmadi: ${data.reason}.`);
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Xatolik');
    }
  };

  const schedule = async () => {
    const ok = await scheduleDailyStudyReminder(state.profile.studyTime);
    setMessage(ok ? 'Android eslatmasi yangilandi.' : 'Native notification faqat Android ilovada ishlaydi.');
  };

  const createLink = async () => {
    try {
      const result = await createAccountLinkCode();
      setLinkCode(result.code);
      setMessage('Link code 15 daqiqa amal qiladi. Uni Web/Android Profile bo‘limiga kiriting.');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Link code xatosi');
    }
  };

  const redeemLink = async () => {
    try {
      const result = await redeemAccountLinkCode(linkInput);
      if (result.ok) {
        setMessage('Telegram va cloud account birlashtirildi.');
        setLinkInput('');
        void syncNow();
      }
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Account link xatosi');
    }
  };

  const exportData = async () => {
    try {
      const data = await exportAccountData();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'english-forge-account-export.json';
      link.click();
      URL.revokeObjectURL(url);
      setMessage('Account eksport tayyorlandi.');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Export xatosi');
    }
  };

  const logout = async () => {
    setMessage('Akkauntdan chiqilmoqda...');
    try {
      await signOut();
    } finally {
      localStorage.removeItem('ef-telegram-session');
      if (telegramSurface) {
        const telegram = (window as any).Telegram?.WebApp;
        if (telegram?.close) {
          telegram.close();
          return;
        }
      }
      window.location.replace('/login');
    }
  };

  const initial = (state.profile.name || 'E').slice(0, 1).toUpperCase();

  return <div className="screen profile-screen premium-profile-screen">
    <div className="screen-head premium-page-head">
      <div>
        <span className="eyebrow">ACCOUNT · STUDY · SYNC</span>
        <h1>Profil va sozlamalar</h1>
        <p>Akkaunt, o‘qish intizomi, ko‘rinish, offline pack va cloud sinxronlash bir joyda.</p>
      </div>
      <Pill tone={entitlement.plan === 'pro' ? 'gold' : entitlement.plan === 'trial' ? 'green' : 'neutral'}>{entitlement.plan.toUpperCase()}</Pill>
    </div>

    <Card className="profile-identity-card">
      <div className="profile-identity-main">
        <div className="profile-avatar premium-profile-avatar">{initial}</div>
        <div className="profile-identity-copy">
          <div className="profile-name-line"><h2>{state.profile.name || 'Learner'}</h2><Pill tone="blue">{state.profile.level}</Pill></div>
          <p>{state.profile.email || 'English Forge cloud account'}</p>
          <span className="profile-status"><i/>Faol foydalanuvchi · Day {calendar.day}/365</span>
        </div>
      </div>
      <div className="profile-identity-stats">
        <div><strong>{calendar.day}</strong><span>Kalendar kuni</span></div>
        <div><strong>{state.progress.xp.toLocaleString()}</strong><span>XP</span></div>
        <div><strong>{state.progress.streak}</strong><span>Streak</span></div>
        <div><strong>{state.progress.reviewDebt}</strong><span>Review debt</span></div>
      </div>
    </Card>

    <div className="premium-profile-grid">
      <div className="premium-profile-column">
        <Card>
          <div className="card-head"><div><span className="eyebrow">O‘QISH SOZLAMALARI</span><h3>Kunlik intizom</h3></div><Icon name="clock"/></div>
          <div className="form-two">
            <label>Dars vaqti<input type="time" value={state.profile.studyTime} onChange={(event) => updateProfile({ studyTime: event.target.value })}/></label>
            <label>Kunlik vaqt<select value={state.profile.dailyMinutes} onChange={(event) => updateProfile({ dailyMinutes: Number(event.target.value) })}><option value={10}>10 min</option><option value={15}>15 min</option><option value={20}>20 min</option><option value={30}>30 min</option><option value={45}>45 min</option></select></label>
          </div>
          <label className="switch-row"><span><strong>Qattiqqo‘l ustoz</strong><small>Recovery va qat’iy eslatmalar</small></span><input type="checkbox" checked={state.settings.strictTeacher} onChange={(event) => updateSettings({ strictTeacher: event.target.checked })}/></label>
          <Button variant="secondary" onClick={() => void schedule()}><Icon name="bell"/> Eslatmani yangilash</Button>
        </Card>

        <Card>
          <div className="card-head"><div><span className="eyebrow">KO‘RINISH</span><h3>Premium glass mavzu</h3></div><Icon name="moon"/></div>
          <div className="theme-choice">{(['system', 'light', 'dark'] as const).map((theme) => <button key={theme} className={state.settings.theme === theme ? 'selected' : ''} onClick={() => updateSettings({ theme })}><Icon name={theme === 'dark' ? 'moon' : 'sun'}/><span>{theme === 'system' ? 'Tizim' : theme === 'light' ? 'Yorug‘' : 'Qorong‘i'}</span></button>)}</div>
          <p className="muted">Light rejim oppoq emas: kulrang translucent material. Dark rejim navy glass palitrada ishlaydi.</p>
        </Card>

        <Card>
          <div className="card-head"><div><span className="eyebrow">OFFLINE-FIRST</span><h3>7 kunlik lesson pack</h3></div><Icon name="download"/></div>
          <p>{offline}</p>
          <Button variant="secondary" onClick={async () => { const pack = await buildOfflinePack(state.progress.day); setOffline(`Cached · Day ${pack.startDay}–${pack.endDay}`); setMessage('Offline pack yangilandi.'); }}><Icon name="download"/> Packni yangilash</Button>
          <p className="muted">Android PRO access offline holatda faqat imzolangan SysOne receipt va offline grace valid bo‘lsa ishlaydi.</p>
        </Card>
      </div>

      <div className="premium-profile-column">
        <Card>
          <div className="card-head"><div><span className="eyebrow">SUBSCRIPTION</span><h3>{entitlement.plan === 'free' ? 'Vocabulary Free' : entitlement.plan === 'trial' ? '7-Day Full Trial' : 'English Forge PRO'}</h3></div><Icon name="shield"/></div>
          <p>{entitlement.plan === 'pro' && entitlement.proUntil ? `SysOne PRO access ${new Date(entitlement.proUntil).toLocaleDateString()} gacha.` : entitlement.plan === 'trial' ? 'Barcha professional funksiyalar vaqtincha ochiq.' : 'Vocabulary + basic SRS ochiq.'}</p>
          <div className="button-row"><Button onClick={() => setRoute('pricing')}>Obuna va access</Button><Button variant="ghost" onClick={() => void logout()}><Icon name="logout"/> Chiqish</Button></div>
        </Card>

        {!telegramSurface ? <Card>
          <div className="card-head"><div><span className="eyebrow">SYSONE PRODUCT KEY</span><h3>PRO entitlement</h3></div><Icon name="key"/></div>
          <p>License Hub’da berilgan bir martalik Product Key.</p>
          <div className="code-entry"><input value={code} onChange={(event) => setCode(event.target.value.toUpperCase())} placeholder="S1-ENGL-XXXX-XXXX-XXXX-XXXX"/><Button onClick={() => void activate()} disabled={!code.trim()}>Faollashtirish</Button></div>
          <small className="muted">Kalit SysOne License Hub’da tekshiriladi va redeem qilinadi.</small>
        </Card> : <Card><span className="eyebrow">TELEGRAM ACCESS</span><h3>Entitlement sync</h3><p>Web/Android’da shu account uchun PRO faollashsa Telegram Mini App’da sync orqali ochiladi.</p></Card>}

        <Card>
          <div className="card-head"><div><span className="eyebrow">CLOUD + ACCOUNT LINK</span><h3>Platformalararo sync</h3></div><Icon name="cloud"/></div>
          <p>{cloudConfigured ? 'Production backend ulangan. Progress va entitlement cloud orqali sinxronlanadi.' : 'Backend env berilmagan — local/offline rejim.'}</p>
          <div className="button-row"><Button variant="secondary" disabled={syncing} onClick={async () => { setSyncing(true); const ok = await syncNow(); setMessage(ok ? 'Cloud + License Hub sync bajarildi.' : 'Cloud sync mavjud emas yoki xato qaytdi.'); setSyncing(false); }}><Icon name="cloud"/> {syncing ? 'Syncing...' : 'Sync now'}</Button></div>
          <div className="account-link-panel">
            {telegramSurface ? <><Button variant="secondary" onClick={() => void createLink()}><Icon name="key"/> Link code yaratish</Button>{linkCode && <div className="generated-code">{linkCode}</div>}<small className="muted">15 daqiqa · bir martalik.</small></> : <><div className="code-entry"><input value={linkInput} onChange={(event) => setLinkInput(event.target.value.toUpperCase())} placeholder="ABCD-EF23"/><Button onClick={() => void redeemLink()} disabled={!linkInput.trim()}>Link</Button></div><small className="muted">Kod Telegram Mini App Profile’dan olinadi.</small></>}
          </div>
        </Card>

        <Card>
          <div className="card-head"><div><span className="eyebrow">PRIVACY</span><h3>Ma’lumotlar nazorati</h3></div><Icon name="shield"/></div>
          <p>Account ma’lumotlarini eksport qilish va delete request yaratish backend workflow orqali bajariladi.</p>
          <div className="button-row"><Button variant="secondary" onClick={() => void exportData()}>Export JSON</Button><Button variant="danger" onClick={async () => { if (!window.confirm('Account delete request yaratilsinmi?')) return; try { await requestAccountDeletion(); setMessage('Delete request yaratildi; account suspend holatiga o‘tdi.'); } catch (error) { setMessage(error instanceof Error ? error.message : 'Delete xatosi'); } }}>Delete request</Button></div>
        </Card>
      </div>
    </div>

    {message && <div className="status-message premium-status-message">{message}</div>}
  </div>;
}
